import CityPageTemplate from "../city-template/CityPageTemplate";
import { mentorConfig } from "./data";

export default function MentorPage() {
  return <CityPageTemplate config={mentorConfig} />;
}